import { videoSteps } from "../CameraWithOverlayVideo/data";

const IMAGE_BUCKETS = [
  "exterior_images_",
  "wheels_images_",
  "treads_images_",
  "interior_images_",
  "exterior_images",
  "wheels_images",
  "treads_images",
  "interior_images",
];

/** Flat list of guided capture steps (16 angles). */
export function getGuidedPhotoSteps() {
  if (Array.isArray(videoSteps)) return videoSteps;
  return [].concat.apply([], Object.values(videoSteps || {}));
}

/** Collect uploaded photo titles from evaluation_images_Details payload. */
export function collectTakenPhotoNames(payload) {
  const root = payload?.data || payload || {};
  const names = new Set();

  IMAGE_BUCKETS.forEach((key) => {
    const list = root[key];
    if (!Array.isArray(list)) return;
    list.forEach((item) => {
      const name = item?.name || item?.title;
      if (name != null && String(name).trim()) {
        names.add(String(name).trim());
      }
    });
  });

  return names;
}

/**
 * First missing guided step index.
 * Returns steps.length when every required photo is present.
 */
export function findResumePhotoIndex(payload, steps = getGuidedPhotoSteps()) {
  const taken = collectTakenPhotoNames(payload);
  for (let i = 0; i < steps.length; i += 1) {
    const title = String(steps[i]?.title || "").trim();
    if (title && !taken.has(title)) return i;
  }
  return steps.length;
}

export function isGuidedPhotoSetComplete(payload, steps = getGuidedPhotoSteps()) {
  if (!steps.length) return false;
  return findResumePhotoIndex(payload, steps) >= steps.length;
}
